var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-chart',{attrs:{"type":_vm.type,"stack-type":_vm.stackType,"height":_vm.height,"series-options":_vm.seriesOptions,"has-statistics":_vm.hasStatistics,"statistics-groups":_vm.monthsData,"context":_vm.context}})}
var staticRenderFns = []

export { render, staticRenderFns }